import { useState } from "react";

import { FAQ_ITEMS } from "../data/faq";
import { FaqItem } from "./FaqItem";

export const FaqSection = () => {
  const [openId, setOpenId] = useState<string | undefined>();

  const toggle = (id: string) => {
    setOpenId((current) => (current === id ? undefined : id));
  };

  return (
    <section className="bg-[#F5FAFA] py-20 md:py-24 xl:py-[120px]">
      <div
        className={[
          "mx-auto flex max-w-[1360px] flex-col gap-10 px-4",
          "md:px-20",
          "xl:flex-row xl:items-start xl:gap-[120px] xl:px-[120px]",
          "2xl:px-0",
        ].join(" ")}
      >
        <h2
          className={[
            "font-bold leading-[1.2] text-[#0D0D0D]",
            "max-w-[289px] text-[23px]",
            "md:max-w-none md:text-[28px]",
            "xl:w-[349px] xl:shrink-0",
          ].join(" ")}
        >
          Trouvez les réponses à vos questions
        </h2>

        <div className="flex w-full flex-col gap-4 xl:flex-1">
          <div className="h-px w-full bg-[#EAEAEA]" />
          {FAQ_ITEMS.map((item) => (
            <FaqItem
              key={item.id}
              item={item}
              isOpen={openId === item.id}
              onToggle={() => toggle(item.id)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
